<template>
    <base-dialog :loading="loading" :value="dialog" :width="400" :title="$t('common.complexity')"
        @input="val => { if (!val) hide() }" @close="hide">
        <kimsa-segmented :items="complexityItems" :value="complexity" :columns="1" @change="complexity = $event" />

        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.save')" :disabled="!valid" :loading="loading" @cancel="hide"
                @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>

import { mapActions, mapState } from "vuex";
import { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
import KimsaSegmented from "@/components/common/inputs/KimsaSegmented";
export default {
    name: "InjuryComplexityDialog",
    components: { BaseDialog, DialogActions, KimsaSegmented },
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            complexity: null,
            message: null,
        }
    },
    computed: {
        ...mapState(['config']),
        valid(vm = this) {
            return !!vm.complexity
        },
        complexityItems(vm = this) {
            if (!vm.config) return []
            return vm.config.injuries.complexity.map(value => ({ name: vm.injuryComplexityLabel(value), value }))
        },
        injuryId(vm = this) {
            return vm.message?.injuryId || null
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
    },
    methods: {
        ...mapActions(['bindConfig']),
        show(message) {
            const vm = this
            vm.loadComplexity(message)
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.complexity = null
            vm.message = null
        },
        async loadComplexity(message) {
            const vm = this
            vm.message = message
            let response = await db.collection('injuries').doc(vm.injuryId).get()
            vm.complexity = response.data()?.complexity || null
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                await db.collection('injuries').doc(vm.injuryId).update({
                    complexity: vm.complexity
                })

                vm.hide()
            })
        }
    },

}
</script>